module.exports = __webpack_public_path__ + "img/company_img.0399ee78.png";